import React from "react";
import { CircularProgress } from "@material-ui/core";
import { validatePermission } from "../../libs/permissions";
import { resolveEnterpriseId } from "../../libs/tenant";
import GroupList from "./GroupList";
import PriceGrid from "./PriceGrid";
import AllProductsList from "./AllProductsList";

// Container do módulo de Produtos. Resolve o enterprise_id do tenant e alterna
// entre a lista de grupos e a grade de preços de um grupo selecionado
// (mesmo padrão de form_layout/index.jsx, que troca entre lista e <Form>).
class Produtos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enterpriseId: null,
      loading: true,
      selectedGroup: null,
      showAll: false,
    };
  }

  componentDidMount() {
    validatePermission();
    resolveEnterpriseId()
      .then((enterpriseId) => this.setState({ enterpriseId, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center", padding: 40 }}>
          <CircularProgress />
        </div>
      );
    }

    if (this.state.selectedGroup) {
      return (
        <PriceGrid
          group={this.state.selectedGroup}
          onBack={() => this.setState({ selectedGroup: null })}
        />
      );
    }

    if (this.state.showAll) {
      return (
        <AllProductsList
          enterpriseId={this.state.enterpriseId}
          onBack={() => this.setState({ showAll: false })}
        />
      );
    }

    return (
      <GroupList
        enterpriseId={this.state.enterpriseId}
        onOpen={(group) => this.setState({ selectedGroup: group })}
        onViewAll={() => this.setState({ showAll: true })}
      />
    );
  }
}

export default Produtos;
